import { isDocSite } from './url'

const DOMAIN = location?.hostname?.includes('dev')
  ? 'https://dev.rivers.ctopt.cn'
  : 'https://rivers.chaitin.cn'

const joinUrl = (url: string) => {
  if (url?.[0] === '/') {
    return new URL(DOMAIN + url)
  } else if (url && url !== 'undefined') {
    return new URL(`${DOMAIN}/${url}`)
  } else {
    return new URL(DOMAIN)
  }
}

export const navbarModuleNavigator = (
  url: string,
  navigator: () => void,
  toModule = false
) => {
  if (toModule) {
    window.open(joinUrl(url), isDocSite ? '_blank' : '_self')
  } else {
    navigator()
  }
}
